import React from 'react';
import {connect} from 'react-redux';
import {BaseComponent as Component} from 'BaseComponent';
import Action from 'actions';
import NumberHelper from 'helpers/number-helper';
import InputText from 'components/atoms/inputs/input-text';

class FilterInput extends Component {
    onBlur(rawValue) {
        const value = this.prepareValue(rawValue);

        const {fieldName} = this.props;
        this.props.dispatch(
            Action.set('InnerSalaryCap', {
                [fieldName]: value,
            }),
        );
    }

    prepareValue(value) {
        const {salaryCap, roundValue = 100, fieldName} = this.props;

        const defaultMin = salaryCap.getInnerMin();
        const defaultMax = salaryCap.getInnerMax();

        let min = defaultMin;
        let max = defaultMax;
        if ('min' === fieldName) {
            min = salaryCap.getOuterMin();
        } else {
            max = salaryCap.getOuterMax();
        }

        return NumberHelper.prepareInt(value).limitByRange(min, max, defaultMin, defaultMax).round(roundValue).get();
    }

    render() {
        const {salaryCap, fieldName, testId} = this.props;
        const value = salaryCap.getInnerCapBoundary(fieldName);

        return <InputText value={value} onBlur={::this.onBlur} keyboard="number" testId={testId} />;
    }
}

function mapStatesToProps(state) {
    const {salaryCap} = state;
    return {
        salaryCap,
    };
}

export default connect(mapStatesToProps)(FilterInput);
